import { AxiosError, isAxiosError } from 'axios';

interface IConsentErrorResponse {
  errorCode: string;
  error: string;
}

export class OfficeConsentNotFoundError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'OfficeConsentNotFound';
  }

  static fromAxiosError(error: unknown): OfficeConsentNotFoundError | null {
    if (!isAxiosError(error)) {
      return null;
    }

    const axiosError = error as AxiosError<IConsentErrorResponse>;

    if (axiosError.response?.status === 404) {
      const errorMessage = axiosError.response.data.error || error.message;
      return new OfficeConsentNotFoundError(errorMessage);
    }

    return null;
  }
}
